import qs from 'qs';
import { client } from '@/client';

// 登录
export function doLogin(params) {
  return client.post('/api/sys_user_service/loginUser', params);
}

// 登出
export function doLogout(thirdPartyOrg) {
  const params = qs.stringify({ thirdPartyOrg }, { addQueryPrefix: true });
  return client.post(`/api/sys_user_service/logout${params}`);
}

// 中信登录
export function doCiticLogin(params) {
  return client.post('/api/sys_third_party_service/loginUserByCiticsinfo', params);
}

// 获取用户信息
export function getUserInfo() {
  return client.get('/api/sys_user_service/getUserInfo');
}

// 修改密码
export function changeUserPwd(params) {
  return client.post('/api/sys_user_service/changeUserPwd', params);
}

// 获取是否为普通用户提示
export function getIsOrdinaryUserPrompt() {
  return client.get('/api/console/getIsOrdinaryUserPrompt');
}
